import { notificationItemType, notificationMessageType } from "./constants";
import moment from "moment";

export const getNotificationText = (notification, sender, senderID,currentUser) => {
  let { item, messageType } = notification;
  // let itemType = (item && item.itemType && item.itemType === notificationItemType.chart) ? 'chart ' : 'tool ';
  let itemType = item && item.itemType ? item.itemType : "";
  let itemName =
    item && item.itemId && item.itemId !== null && item.itemId.name
      ? item.itemId.name
      : "";
  if (notification) {
    switch (messageType) {
      case notificationMessageType.itemCommented:
        return `${sender} commented on your ${itemType} "${itemName}"`;
      case notificationMessageType.itemEdited:
        return `${sender} has edited your ${itemType} "${itemName}"`;
      case notificationMessageType.itemShared:
        if (item && item.itemID && senderID._id === item.itemID) {
          return `${sender} shared your ${itemType}: "${itemName}".`;
        } else {
          return `${sender} shared your ${itemType} "${itemName}"`;
        }
      case notificationMessageType.itemSharedWithYou:
        if (item && item.itemID && senderID._id === item.itemID) {
          return `${sender} shared your ${item.itemType}: "${itemName}".`;
        } else {
          return `${sender} shared this ${item.itemType} "${itemName}" with you.`;
        }
      case notificationMessageType.sharedYourItem:
        return `${sender} shared your ${itemType}: "${itemName}".`;

      case notificationMessageType.group_invite:
        return `Added to group ${itemName}`;

      case notificationMessageType.tool_invite:
        let format = "MMM D, YYYY";
        // 'ddd, MMM Do YYYY'
        let startDate = item.itemId.startDate;
        let startDate_format = moment(startDate).format(format);
        return `Invited to ${itemName} ${
          startDate_format ? `on ${startDate_format}` : ""
        }`;

      case notificationMessageType.itemSharedPublicly:
        if (item && item.itemID && senderID._id === item.itemID) {
          return `${sender} shared your ${itemType}: "${itemName}".`;
        } else {
          return `${sender} shared your ${itemType} "${itemName}"`;
        }
      case notificationMessageType.itemSharedWithOffice:
        return `${sender} shared this ${itemType} with your office "${itemName}"`;
      case notificationMessageType.officeMateJoined:
        return `${sender} just joined your Enterprise. Your team is growing!`;
      case notificationMessageType.recommendedToolAdded:
        return `Check out this new recommended resource for your office "${itemName}"`;
      case notificationMessageType.userMentioned:
        return `${sender} mentioned you in a post!`;
      case notificationMessageType.storyResponse:
        return `${sender} commented on your post!`;
      case notificationMessageType.storyReaction:
        return `${sender} reacted to your post!`;
      case notificationMessageType.taskAssigned:
        return `${sender} has assigned you a task`;
      case notificationMessageType.taskLinked:
        return `Action has been linked to an Enterprise Objective`;
      case notificationMessageType.taskUnlinked:
        return `Action has been unlinked from an Enterprise Objective`;
      case notificationMessageType.taskCreated:
        return `${sender} has assigned you a task`;
      case notificationMessageType.taskUpdate:
        return `A task of yours has been updated`;
      case notificationMessageType.taskCompleted:
        return `A task of yours has been completed`;
      case notificationMessageType.taskIncomplete:
        return `A task of yours has been marked incomplete`;
      case notificationMessageType.taskArchived:
        return `A task of yours has been archived`;
      case notificationMessageType.story_flagged:
        if(currentUser.orgAdmin){
          return `${sender}  reported a story written by ${item.itemId && item.itemId._id && item.itemId.userId &&item.itemId.userId._id ? item.itemId.userId._id === currentUser._id ? "You": `${item.itemId.userId.firstName} ${item.itemId.userId.lastName}`  :"User"  }`;
        }else{
          return `${sender} reported your story. Click here to see`;
        }
      case notificationMessageType.comment_flagged:
        if(currentUser.orgAdmin){
          return `${sender}  reported a comment written by ${item.itemId && item.itemId._id && item.itemId.userId &&item.itemId.userId._id ? item.itemId.userId._id === currentUser._id ? "You": `${item.itemId.userId.firstName} ${item.itemId.userId.lastName}`  :"User"  }`;

        }else{
          return `${sender} reported your comment. Click here to see`;

        }

      case notificationMessageType.trivvyInvited:
        return `${sender} invited you for a Trivvy ${notification.item.itemTitle}`
    }
  }
};
